/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

export enum V1UserTypeEnum {
  'userTypeNew' = 'new',
  'userTypeOld' = 'old',
}

export type V1UserType = V1UserTypeEnum